import React, { useCallback, useMemo, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import FilterHeader from '../FilterHead';
import OptionTile from './OptionTile';
import { getAppliedFilterValue } from '../../../../../helpers/utils';
import OmnitureUtils from '../../../../../../common/utils/Omniture/OmnitureUtils';

import './styles.scss';

const TilesFilter = ({
  filterData,
  handleFilterChange,
  showOverlayFilterLoader,
  filterIndex,
  isCollapsedOnInit = false,
}) => {
  const [isCollapsed, setCollapsed] = useState(!isCollapsedOnInit);
  const [search] = useSearchParams();

  const handleCollapsed = () => {
    setCollapsed(!isCollapsed);
  };

  const appliedValues = useMemo(
    () => getAppliedFilterValue(filterData?.urlParam, search),
    [filterData?.urlParam, search]
  );

  const handleOptionClick = useCallback(
    (values, { prop54 } = {}) => {
      OmnitureUtils.trackClickEvent({
        prop54: prop54.replace('<urlParam>', filterData?.urlParam),
      });
      handleFilterChange({ urlParam: filterData?.urlParam, values });
    },
    [handleFilterChange]
  );

  return (
    <div className="filtersOuter">
      {showOverlayFilterLoader && <div className="filtersOverlayLoader" />}
      <FilterHeader
        isCollapsed={isCollapsed}
        handleCollapsed={handleCollapsed}
        name={filterData?.name}
        filterIndex={filterIndex}
      />
      {isCollapsed && (
        <div className="offerSection">
          {filterData?.listingFilterValues?.map(filterOption => (
            <OptionTile
              filterOption={filterOption}
              key={filterOption.uniqueId}
              filterStats={filterData?.filterStats?.discreteStats}
              handleOptionClick={handleOptionClick}
              appliedValues={appliedValues}
              filterUrlParam={filterData?.urlParam}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default TilesFilter;
